import config from "../config/envConfig";
import { createMessage } from "../manager/cardManager";
import { impexDateFormat } from "../manager/dateManager";


const poAknowledgeColumns = [
  {
    head: "PART NUMBER",
    key: "PartNo",
  },
  {
    head: "PO NUMBER",
    key: "PONumber",
  },
  {
    head: "QUANTITY",
    key: "Qty",
  },
  {
    head: "DUE DATE",
    key: "DueDate",
  },
];

const poPartPriceUpdateColumns = [
  {
    head: "PART NUMBER",
    key: "PartNo",
  },
  {
    head: "QUANTITY",
    key: "Qty",
  },
  {
    head: "PART PRICE",
    key: "RatePerUnit",
  },
];

const getContentArea = (content) => {
  return `
    <p
      style="
        font-family: sans-serif;
        font-size: 14px;
        font-weight: normal;
        margin: 0;
        margin-bottom: 6px;
      "
    >
        ${content}
     </p>
    `;
};

const createHeaderRow = (headerData) => {
  var header = "";
  for (const item of headerData) {
    header += `<th style="border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
    color: #3366ff;">${item.head}</th>`;
  }
  return header;
};

const createDataRow = (po, headerData) => {
  var dataRows = "";
  for (const item of po) {
    var dataCell = "";
    for (const colItem of headerData) {
      dataCell += `<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">${
        colItem.key === "DueDate"
          ? impexDateFormat(item[colItem.key])
          : item[colItem.key]
      }</td>`;
    }
    dataRows += `<tr>${dataCell}</tr>`;
  }
  return dataRows;
};

const createTable = (headerCol, po) => {
  return `
    <table style="border-collapse: collapse; width: 100%">
        <thead style="background-color: #eff4ff !important">
            ${createHeaderRow(headerCol)}
        </thead>
        <tbody>
            ${createDataRow(po, headerCol)}
        </tbody>
    </table>
`;
};

const generateLink = (POID) => {
  return `<a href=${config.appHost}/impex/purchase-orders/${POID}>Go to Impex</a>`;
};

const createLink = (link) => {
  return `<a href=${link}>${link}</a>`;
};

const emailLayoutCreator = (mainContent) => {
  return `<!DOCTYPE html>
    <html>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        <style>
          @media only screen and (max-width: 620px) {
            table.body h1 {
              font-size: 28px !important;
              margin-bottom: 10px !important;
            }
    
            table.body p,
            table.body ul,
            table.body ol,
            table.body td,
            table.body span,
            table.body a {
              font-size: 16px !important;
            }
    
            table.body .wrapper,
            table.body .article {
              padding: 10px !important;
            }
    
            table.body .content {
              padding: 0 !important;
            }
    
            table.body .container {
              padding: 0 !important;
              width: 100% !important;
            }
    
            table.body .main {
              border-left-width: 0 !important;
              border-radius: 0 !important;
              border-right-width: 0 !important;
            }
    
            table.body .btn table {
              width: 100% !important;
            }
    
            table.body .btn a {
              width: 100% !important;
            }
    
            table.body .img-responsive {
              height: auto !important;
              max-width: 100% !important;
              width: auto !important;
            }
          }
    
          @media all {
            .ExternalClass {
              width: 100%;
            }
    
            .ExternalClass,
            .ExternalClass p,
            .ExternalClass span,
            .ExternalClass font,
            .ExternalClass td,
            .ExternalClass div {
              line-height: 100%;
            }
          }
        </style>
      </head>
    
      <body
        style="
          background-color: #f6f6f6;
          font-family: sans-serif;
          -webkit-font-smoothing: antialiased;
          font-size: 14px;
          line-height: 1.4;
          margin: 0;
          padding: 0;
          -ms-text-size-adjust: 100%;
          -webkit-text-size-adjust: 100%;
        "
      >
        <table
          role="presentation"
          border="0"
          cellpadding="0"
          cellspacing="0"
          class="body"
          style="
            border-collapse: separate;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            background-color: #f6f6f6;
            width: 100%;
          "
          width="100%"
          bgcolor="#f6f6f6"
        >
          <tr>
            <td
              style="font-family: sans-serif; font-size: 14px; vertical-align: top"
              valign="top"
            >
              &nbsp;
            </td>
            <td
              class="container"
              style="
                font-family: sans-serif;
                font-size: 14px;
                vertical-align: top;
                display: block;
                max-width: 580px;
                padding: 10px;
                width: 580px;
                margin: 0 auto;
              "
              width="580"
              valign="top"
            >
              <div
                class="content"
                style="
                  box-sizing: border-box;
                  display: block;
                  margin: 0 auto;
                  max-width: 580px;
                  padding: 10px;
                "
              >
                <table
                  role="presentation"
                  class="main"
                  style="
                    border-collapse: separate;
                    mso-table-lspace: 0pt;
                    mso-table-rspace: 0pt;
                    background: #ffffff;
                    border-radius: 3px;
                    width: 100%;
                  "
                  width="100%"
                >
                  <tr>
                    <td
                      class="wrapper"
                      style="
                        font-family: sans-serif;
                        font-size: 14px;
                        vertical-align: top;
                        box-sizing: border-box;
                        padding: 20px;
                      "
                      valign="top"
                    >
                      <table
                        role="presentation"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        style="
                          border-collapse: separate;
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          width: 100%;
                        "
                        width="100%"
                      >
                        <tr>
                          <td
                            style="
                              font-family: sans-serif;
                              font-size: 14px;
                              vertical-align: top;
                            "
                            valign="top"
                          >
                          ${mainContent}
                         <img src="https://dev.ataimpex.com/logo.jpg" alt="No image" style="margin-top: 6px; width: 80px; height:30px"/>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
            <td
              style="font-family: sans-serif; font-size: 14px; vertical-align: top"
              valign="top"
            >
              &nbsp;
            </td>
          </tr>
        </table>
      </body>
    </html>`;
};

export const poAknowledgeEmailTemplate = (po, poDetails) => {
  var emailContent = "";
  var bodyList = [
    "Dear Impex Team",
    `We acknowledge the receipt of your purchase order number ${po.PONumber}. 
          We are pleased to accept your order and look forward to doing business with you.`,
    createTable(poAknowledgeColumns, poDetails),
    "Should you have any queries regarding your order, please call our customer support number or contact me directly.",
    "Thank you again for your order and business.",
    generateLink(poDetails[0].POID),
  ];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};

export const followUpEmailTemplate = (followUpInfo) => {
  var emailContent = "";
  var bodyList = ["Dear Supplier", createMessage(followUpInfo)];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};

export const poUpdateEmailTemplate = (oldPO, updatedPO, PONumber) => {
  var emailContent = "";
  var bodyList = [
    "Dear Supplier",
    `Please find attached Revised Purchase Order ${PONumber} .Kindly approve it via Portal.`,
    "Original PO Details:",
    createTable(poAknowledgeColumns, oldPO),
    "Revised PO Details: ",
    createTable(poAknowledgeColumns, updatedPO),
    "If you have any queries, please contact the Impex Team",
    "Thanks",
    "Impex",
  ];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};

export const cargoReadyEmailTemplate = (poDetails, PONumber) => {
  var emailContent = "";
  var bodyList = [
    "Dear Impex Team",
    `PO ${PONumber} is ready to depart from Supplier’s facility. Please be ready for GRN.`,
    createTable(poAknowledgeColumns, poDetails),
    "If you have any queries, please contact the Impex Team",
    "Thanks",
    "Impex",
  ];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};

export const poPartPriceUpdateEmailTemplate = (updatedPO, oldPriceData) => {
  var emailContent = "";
  var bodyList = [
    "Dear Impex Team",
    `${oldPriceData[0].Supplier}, raised Price change request. Please take action and update the Price in Part master in ERP.`,
    "Original part price: ",
    createTable(poPartPriceUpdateColumns, oldPriceData),
    "Proposed part price: ",
    createTable(poPartPriceUpdateColumns, updatedPO),
  ];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};

export const wrongAmountAlert = (
  invoiceDetails,
  userEnteredAmount,
  systemCalculatedAmount
) => {
  var emailContent = "";
  var bodyList = [
    "Dear Impex Team",
    "Supplier, tried to upload incorrect amount Invoice, Kindly check with Supplier.",
    `Amount Entered: ${userEnteredAmount}`,
    `Expected Amount: ${systemCalculatedAmount}`,
    createTable(
      [
        {
          head: "PO NUMBER",
          key: "PONumber",
        },
        ...poAknowledgeColumns,
      ],
      invoiceDetails
    ),
    "Thanks",
  ];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};

export const getUserCreateMailTemplate = (payload, password) => {
  var emailContent = "";
  var bodyList = [
    `Hello ${payload.FirstName} ${payload.LastName}`,
    ``,
    ``,
    `Welcome to Impex Portal! Utilize our portal to automate and centrally manage your orders.`,
    `Here are your credentials:`,
    ``,
    ``,
    `Username: ${payload.LoginId}`,
    `Password: ${password}`,
    `Impex Portal Link:${createLink(window.location.origin)}`,
    `Quick Video Library:${createLink(
      "https://atahive.com/content/public/content/100"
    )} `,
    ``,
    `Please refer to the attached user guide for your understanding.`,
    ``,
    `In case of any issue or difficulty, you can contact Angad Chhatwal(angadc@quloi.com), Abhishek Hadgekar (abhishek.h@quloi.com) and Ganesh Patil (ganesh@quloi.com) from Customer success team.`,
    ``,
    `Thanks & Regards,`,
  ];
  for (const item of bodyList) {
    emailContent = emailContent + getContentArea(item);
  }
  return emailLayoutCreator(emailContent);
};
